<template>
    <div>
        <Breadcrumbs main="Admin" submain="Portfolio" title="Contact Info" />
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12" v-if="!loading && !error">
                    <px-card>
                        <!-- {{ details }} -->
                        <div slot="with-padding">
                            <div class="form theme-form">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Phone Title - 1</label>
                                            <input class="form-control" type="text" placeholder="Enter phone title" v-model="contact_info.phone_title_1">
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Phone Number</label>
                                            <input class="form-control" type="text" placeholder="Enter phone number" v-model="contact_info.phone_no_1">
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Phone Title - 2</label>
                                            <input class="form-control" type="text" placeholder="Enter phone title" v-model="contact_info.phone_title_2">
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Phone Number</label>
                                            <input class="form-control" type="text" placeholder="Enter phone number" v-model="contact_info.phone_no_2">
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Email - 1</label>
                                            <input class="form-control" type="text" placeholder="Enter email address" v-model="contact_info.email_1">
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Email - 2</label>
                                            <input class="form-control" type="text" placeholder="Enter email address" v-model="contact_info.email_2">
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="form-group">
                                            <label>Address</label>
                                            <input class="form-control" type="text" placeholder="Enter address" v-model="contact_info.address">
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row">
                                    <div class="col">
                                        <div class="form-group mb-0">
                                            <button  @click="onSubmit()" class="btn btn-primary mr-3">Update Contact Info</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </px-card>
                </div>
    
                <div class="col-sm-12" v-else>
                    <div class="card">
                        <div class="card-body">
                            <div class="loader-box">
                                <div class="loader-10"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>

<script>
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import { mapState } from 'vuex';

export default {
    data() {
        return {
            contact_info:{
                phone_title_1:'', 
                phone_title_2:'',
                phone_no_1:'',
                phone_no_2:'',
                email_1:'',
                email_2:'',
                address:''
            }
        };
    },

    watch: {
        details(oldValue, newValue) {
            this.contact_info.phone_title_1 = this.details.info?.phone_title_1 ? this.details.info.phone_title_1 : "";
            this.contact_info.phone_title_2 = this.details.info?.phone_title_2 ? this.details.info.phone_title_2 : "";
            this.contact_info.phone_no_1 = this.details.info?.phone_no_1 ? this.details.info.phone_no_1 : "";
            this.contact_info.phone_no_2 = this.details.info?.phone_no_2 ? this.details.info.phone_no_2 : "";
            this.contact_info.email_1 = this.details.info?.email_1 ? this.details.info.email_1 : "";
            this.contact_info.email_2 = this.details.info?.email_2 ? this.details.info.email_2 : "";
            this.contact_info.address = this.details.info?.address ? this.details.info.address : "";
        }
    },
    
    mounted() {
        this.$store.dispatch("contact/fetchContactInfoDetail")
    },

    computed: {
        ...mapState({
            details: state => state.contact.contactInfoDetail,
            loading: state => state.contact.submitLoading,
            error: state => state.contact.submitError,
        })

    },
    methods: {
        onSubmit() {
            this.$store.dispatch("contact/addContactInfo", {
                contact:this.contact_info,
            } ).then(response => {
                if (response.code == 200) {
                    this.contact_info.phone_title_1=''
                    this.contact_info.phone_title_2=''
                    this.contact_info.phone_no_1=''
                    this.contact_info.phone_no_2=''
                    this.contact_info.email_1=''
                    this.contact_info.email_2=''
                    this.contact_info.address=''
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
    